<template>
	<div class="dialog-box">
		<el-dialog :show-close="true" :visible.sync="centerDialogVisible" width="70%" center>
			<el-table :data="tableData" style="width: 100%;margin-top: 20px;">
				<el-table-column align="center" prop="name" label="用户信息"> </el-table-column>
				<el-table-column align="center" prop="time" label="时间"></el-table-column>
				<el-table-column align="center" prop="incomeType" label="收支类型">
					<template slot-scope="scope">
						<span v-if="scope.row.incomeType == 0">代收</span>
						<span v-if="scope.row.incomeType == 1">收款</span>
						<span v-if="scope.row.incomeType == 2">代收（续）</span>
						<span v-if="scope.row.incomeType == 3">收款（续）</span>
						<span v-if="scope.row.incomeType == 4">付款</span>
						<span v-if="scope.row.incomeType == 5">退款</span>
						<span v-if="scope.row.incomeType == 6">付款（续）</span>
						<span v-if="scope.row.incomeType == 7">退款（续）</span>
						<span v-if="scope.row.incomeType == 8">收款</span>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="feeType" label="费用类型">
					<template slot-scope="scope">
						<span v-if="scope.row.feeType == 0">租金</span>
						<span v-if="scope.row.feeType == 1">油费</span>
						<span v-if="scope.row.feeType == 2">服务费</span>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="fee" label="金额"></el-table-column>
			</el-table>
		</el-dialog>
	</div>
</template>
<script>
	export default {
		name: 'accountDialog',
		data() {
			return {
				centerDialogVisible: false,
				tableData: []
			}
		},
		methods: {
			showDialog(val) {
				this.centerDialogVisible = true
				this.tableData = val
			}
		}
	}
</script>
<style lang="less" scoped>
	.dialog-box {
		font-size: 0;

		.dialog-tit {
			position: absolute;
			text-align: center;
			width: 20px;
			height: 20px;
			right: 20px;
			top: 20px;
			background: #FFF;
			border-radius: 50%;
			color: #000;
			font-size: 16px;
			cursor: pointer;
		}

		/deep/ .el-table thead {
			color: #282828;
		}

		/deep/ .el-table .cell {
			font-size: .14rem;
		}

		/deep/ .el-dialog--center .el-dialog__body {
			padding-top: 0;
			padding-bottom: 1rem;
		}
	}
</style>
